var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import { ExpandMore } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import useStyles from './style';
var ExpandIcon = function (_a) {
    var _b;
    var expanded = _a.expanded;
    var classes = useStyles();
    return (_jsx(IconButton, __assign({ className: classnames(classes.expand, (_b = {},
            _b[classes.expandOpen] = expanded,
            _b)), "data-testid": "expand-button" }, { children: _jsx(ExpandMore, {}, void 0) }), void 0));
};
export default ExpandIcon;
